import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class CurrentDatetimeAPI extends ComponentAPI {
    /**
     * Returns a boolean indicating if the value is frozen
     */
    isFrozen() {
        return this.state.frozen;
    }
    /**
     * Sets if the value should be updated every second
     * @param frozen - If the value should be updated every second
     */
    setFrozen(frozen) {
        this.setState({ frozen });
    }
    /**
     * Returns the format used to format the current date
     */
    getFormat() {
        return this.state.format;
    }
    /**
     * Updates the format used to format the current date
     * @param format - The format used to format the current date
     */
    setFormat(format) {
        this.setState({ format });
    }
}
export { CurrentDatetimeAPI, };
//# sourceMappingURL=current-datetime-api.js.map